exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes spring {\n    0% { transform: scale(1) translateY(0); }\n    10% { transform: scale(1.2, 0.6); }\n    30% { transform: scale(0.8, 1.1) translateY(-50px); }\n    50% { transform: scale(1) translateY(0); }\n    100% { transform: translateY(0); }\n}\n\n#house-loader {\n    animation: spring 1s;\n    animation-timing-function: ease;\n    animation-iteration-count: infinite;\n}", ""]);

// exports
